module.exports = "<ion-view\r\n  class=\"wizard\"\r\n  title=\"{{::('video.chat.title' | translate)}}\"\r\n  cache-view=\"false\"\r\n>\r\n  <react-component\r\n    class=\"VideoChatSessionLayout\"\r\n    name=\"VideoChatSession\"\r\n    props=\"videoChat.props\"\r\n    watch-depth=\"reference\">\r\n  </react-component>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/comments/ngTemplates/video-chat.html
// module id = 2364
// module chunks = 0